import { useState, useEffect } from 'react';
import api from '../utils/api';

/**
 * Returns { aiEnabled: bool, aiLoading: bool }
 * Fetches once and caches for the session — cheap call.
 */
let _cache = null; // module-level cache so repeated mounts don't re-fetch

const useAIEnabled = () => {
    const [aiEnabled, setAiEnabled] = useState(_cache ?? false);
    const [aiLoading, setAiLoading] = useState(_cache === null);

    useEffect(() => {
        if (_cache !== null) return; // already fetched

        let cancelled = false;
        api.getAISettings()
            .then(res => {
                if (cancelled) return;
                const enabled = res?.success ? (res.settings?.enabled ?? false) : false;
                _cache = enabled;
                setAiEnabled(enabled);
            })
            .catch(() => {
                if (!cancelled) setAiEnabled(false);
            })
            .finally(() => {
                if (!cancelled) setAiLoading(false);
            });

        return () => { cancelled = true; };
    }, []);

    return { aiEnabled, aiLoading };
};

export default useAIEnabled;